"use client";

import { usePathname } from "next/navigation";
import Nav from "@/components/layout/navigation";
import CoinGeckoPriceBanner from "@/components/layout/coingecko-price-banner";
import { PortfolioSidebar } from "@/components/wallet/portfolio-sidebar";
import { ErrorBoundary } from "@/components/ui/error-boundary";

export function ShellWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isWidget = pathname === "/widget" || pathname.startsWith("/widget/");

  if (isWidget) {
    return <>{children}</>;
  }

  return (
    <>
      <ErrorBoundary fallback={null}>
        <PortfolioSidebar />
      </ErrorBoundary>
      <div className="app-shell flex flex-col min-h-screen w-full max-w-[100vw] overflow-x-hidden">
        <CoinGeckoPriceBanner />
        <Nav />
        <div className="app-content h-full w-full max-w-[100vw] overflow-x-hidden flex place-items-center place-content-center pt-[60px] pb-40 sm:pb-20 px-2 sm:px-4 lg:px-8">
          {children}
        </div>
      </div>
    </>
  );
}
